// https://vuex.vuejs.org/en/state.html
import auth from '@/auth'

export default {
  transactions:[
    {
      id:0,
      deposit_external_id:"",
      deposit_transaction_external_id: "T" + Math.floor(Math.random() * (1000000000 - 1 + 1)) + 1,
      carrier_external_id:"",
      deposit_transaction_reference_number:"",
      statement_external_id:"",
      amount:0.0,
      is_active: true,
      create_user: "webuser",
      update_user: "webuser"
    }
  ],
  lang: initLang,
  layout: auth.loggedIn ? "layout" : "login",
  current_user:null
}

const LANG_KEY = 'language'

const initLang = (() => {
  let lang = window.localStorage.getItem(LANG_KEY) || window.navigator.language
  return lang || 'en'
})()